import React from 'react';
import styled from 'styled-components';
import { localize } from 'react-localize-redux';
import { Field, reduxForm } from 'redux-form';
import * as validator from 'helpers/Validator';
import { DatePicker } from 'redux-form-material-ui';
import * as formatter from 'helpers/Formatter';
import moment from 'moment';

const StyledFieldsContainer = styled.div`
  text-align: center;
  width: 100%;
`;

let RentReceiptGenerator = props => {
  const { handleSubmit, translate } = props;

  return (
    <form onSubmit={handleSubmit}>
      <StyledFieldsContainer>
        <Field
          name="start_date"
          component={DatePicker}
          openToYearSelection={true}
          formatDate={formatter.reformatDate}
          validate={validator.required}
          floatingLabelText={translate('startDate')}
          textFieldStyle={{ width: '170px', fontSize: '14px', margin: 'auto' }}
          style={{ marginTop: '-20px', fontSize: '14px' }}
        />
        <Field
          name="end_date"
          component={DatePicker}
          openToYearSelection={true}
          formatDate={formatter.reformatDate}
          validate={validator.required}
          floatingLabelText={translate('endDate')}
          textFieldStyle={{ width: '170px', fontSize: '14px' }}
          style={{ marginTop: '-30px', fontSize: '14px', margin: 'auto' }}
        />
      </StyledFieldsContainer>
    </form>
  );
};

RentReceiptGenerator = reduxForm({
  form: 'rent_receipt',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  initialValues: {
    start_date: moment()
      .subtract(1, 'year')
      .startOf('year')
      .toDate(),
    end_date: moment()
      .subtract(1, 'year')
      .endOf('year')
      .toDate(),
  },
})(RentReceiptGenerator);

export default localize()(RentReceiptGenerator);
